import { render, staticRenderFns } from "./Left.vue?vue&type=template&id=a19e71a6&scoped=true&"
import script from "./Left.vue?vue&type=script&lang=js&"
export * from "./Left.vue?vue&type=script&lang=js&"
import style0 from "./Left.vue?vue&type=style&index=0&id=a19e71a6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a19e71a6",
  null
  
)

export default component.exports